if (!customElements.get('cart-offer-progress')) {
  class CartOfferProgress extends HTMLElement {
    static pending = null;
    static revision = 0;
    connectedCallback() {
      this.threshold = Number(this.dataset.threshold) || 3;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => CartOfferProgress.refresh());
      }
      CartOfferProgress.refresh();
    }
    disconnectedCallback() { this.unsubscribe?.(); }
    static refresh() {
      const revision = ++this.revision;
      clearTimeout(this.pending);
      this.pending = setTimeout(async () => {
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + '?sections=lookstan-offer-count', { headers: { Accept: 'application/json' }, cache: 'no-store' });
          if (!response.ok) return;
          const sections = await response.json();
          if (revision !== this.revision || !sections['lookstan-offer-count']) return;
          const doc = new DOMParser().parseFromString(sections['lookstan-offer-count'], 'text/html');
          const countElement = doc.querySelector('[data-lookstan-offer-count]');
          if (!countElement) return;
          const count = Number(countElement.textContent.trim());
          if (!Number.isFinite(count) || count < 0) return;
          document.querySelectorAll('cart-offer-progress').forEach(element => element.render(count));
          CartOfferProgress.maybePopup(count);
          document.querySelectorAll('free-shipping-bar').forEach(element => element.hidden = count > 0);
          document.querySelectorAll('lookstan-fifth-pick').forEach(element => element.update?.(count, countElement.dataset.fifthSeed, countElement.dataset.cartSignature, doc.querySelector("[data-fifth-results]")));
          const savingsElement = doc.querySelector('[data-offer-savings]');
          if (savingsElement) {
            const savings = Number(savingsElement.dataset.discountCents);
            if (Number.isFinite(savings) && savings >= 0) {
              document.querySelectorAll('cart-offer-progress').forEach(element => element.renderSavings(savings, savingsElement.textContent.trim()));
            }
          }
        } catch (_) {}
      }, 60);
    }
    static maybePopup(count) {
      // 2nd eligible piece just added: 15% is on, nudge toward the free 3rd piece (2026-10-18).
      let previous = null;
      try {
        previous = sessionStorage.getItem('ls_offer_prev');
        sessionStorage.setItem('ls_offer_prev', String(count));
      } catch (_) { return; }
      if (count < 2) { try { Object.keys(sessionStorage).filter(k => k.startsWith('ls_offer_pop_')).forEach(k => sessionStorage.removeItem(k)); } catch (_) {} }
      if (previous === null) return;
      const before = Number(previous);
      if (!Number.isFinite(before) || count <= before || count % 3 !== 2) return;
      const seenKey = 'ls_offer_pop_' + count;
      try { if (sessionStorage.getItem(seenKey)) return; sessionStorage.setItem(seenKey, '1'); } catch (_) { return; }
      const ar = (document.documentElement.lang || '').toLowerCase().startsWith('ar');
      const root = window.Shopify?.routes?.root || '/';
      const text = ar
        ? { title: 'اتفعّل خصم ١٥٪ 🎉', body: 'ضيف قطعة كمان… والتالتة عليك مجانًا 🎁', cta: 'اختار القطعة المجانية', later: 'مش دلوقتي' }
        : { title: '15% off unlocked 🎉', body: 'Add 1 more piece — the 3rd is FREE 🎁', cta: 'Pick my free piece', later: 'Not now' };
      document.querySelector('.ls-offer-pop')?.remove();
      const pop = document.createElement('div');
      pop.className = 'ls-offer-pop';
      pop.setAttribute('role', 'dialog');
      pop.setAttribute('aria-modal', 'true');
      pop.setAttribute('dir', ar ? 'rtl' : 'ltr');
      pop.innerHTML = '<div class="ls-offer-pop__card"><button type="button" class="ls-offer-pop__x" aria-label="Close">×</button>'
        + '<p class="ls-offer-pop__title"></p><p class="ls-offer-pop__body"></p>'
        + '<a class="ls-offer-pop__cta"></a><button type="button" class="ls-offer-pop__later"></button></div>';
      pop.querySelector('.ls-offer-pop__title').textContent = text.title;
      pop.querySelector('.ls-offer-pop__body').textContent = text.body;
      const cta = pop.querySelector('.ls-offer-pop__cta');
      cta.textContent = text.cta;
      cta.href = root + 'collections/all-product';
      pop.querySelector('.ls-offer-pop__later').textContent = text.later;
      const close = () => pop.remove();
      pop.addEventListener('click', event => { if (event.target === pop) close(); });
      pop.querySelectorAll('.ls-offer-pop__x, .ls-offer-pop__later').forEach(button => button.addEventListener('click', close));
      if (!document.getElementById('ls-offer-pop-style')) {
        const style = document.createElement('style');
        style.id = 'ls-offer-pop-style';
        style.textContent = '.ls-offer-pop{position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center;padding:16px}'
          + '.ls-offer-pop__card{position:relative;background:#fff;color:#111;border-radius:14px;max-width:360px;width:100%;padding:28px 22px 18px;text-align:center;box-shadow:0 12px 40px rgba(0,0,0,.25)}'
          + '.ls-offer-pop__x{position:absolute;top:8px;inset-inline-end:12px;background:none;border:0;font-size:26px;line-height:1;color:#666;cursor:pointer}'
          + '.ls-offer-pop__title{margin:0 0 6px;font-size:22px;font-weight:800}'
          + '.ls-offer-pop__body{margin:0 0 18px;font-size:16px}'
          + '.ls-offer-pop__cta{display:block;background:#c62026;color:#fff;text-decoration:none;font-weight:700;padding:14px;border-radius:10px;font-size:16px}'
          + '.ls-offer-pop__later{margin-top:10px;background:none;border:0;color:#666;text-decoration:underline;font-size:14px;cursor:pointer}';
        document.head.appendChild(style);
      }
      document.body.appendChild(pop);
    }
    renderSavings(amount, text) {
      const savingsElement = this.querySelector('[data-offer-savings]');
      if (!savingsElement) return;
      savingsElement.hidden = amount <= 0;
      savingsElement.dataset.discountCents = String(amount);
      const message = amount > 0 ? text : '';
      if (savingsElement.textContent !== message) savingsElement.textContent = message;
    }
    render(count) {
      // Buy 2 Get 1 Free: progress is counted in groups of 3 eligible items.
      const safe = Math.max(0, count);
      const freeCount = Math.floor(safe / 3);
      const remainder = safe % 3;
      const full = safe > 0 && remainder === 0;
      const shown = full ? 3 : remainder;
      let message;
      if (safe === 0) message = this.getAttribute('data-message-0') || '';
      else if (full) message = freeCount >= 2 ? (this.getAttribute('data-message-many') || '').replace('[n]', String(freeCount)) : (this.getAttribute('data-message-3') || '');
      else if (freeCount === 0) message = this.getAttribute('data-message-' + remainder) || '';
      else message = (this.getAttribute('data-message-next') || '').replace('[n]', String(freeCount));
      this.dataset.itemCount = String(count);
      this.classList.toggle('has-first-reward', full);
      this.classList.toggle('has-final-reward', full);
      this.classList.toggle('is-tier', shown >= 2);
      this.querySelector('[data-offer-fill]').style.width = (shown === 3 ? 100 : shown === 2 ? 50 : 0) + '%';
      this.querySelector('[data-offer-count]').textContent = String(shown);
      const track = this.querySelector('[role="progressbar"]');
      track.setAttribute('aria-valuenow', String(shown));
      track.setAttribute('aria-valuetext', message);
      this.querySelectorAll('[data-offer-step]').forEach((step,index) => step.classList.toggle('is-complete',index < shown));
      const messageElement = this.querySelector('[data-offer-message]');
      if (messageElement.textContent !== message) messageElement.textContent = message;
    }
  }
  customElements.define('cart-offer-progress', CartOfferProgress);
  // Refresh the offer state after any cart change, whichever component made it (quick add, drawer picks, etc.).
  if (!window.__lsOfferFetchHooked && typeof window.fetch === 'function') {
    window.__lsOfferFetchHooked = true;
    const originalFetch = window.fetch.bind(window);
    window.fetch = (...args) => {
      const request = args[0];
      const url = typeof request === 'string' ? request : request?.url || '';
      const promise = originalFetch(...args);
      if (/\/cart\/(add|change|update)(\.js)?/.test(url)) {
        promise.then(response => { if (response.ok) CartOfferProgress.refresh(); }).catch(() => {});
      }
      return promise;
    };
  }
}
